import { render, staticRenderFns } from "./hotSell.vue?vue&type=template&id=3bdba48b&scoped=true&"
import script from "./hotSell.vue?vue&type=script&lang=js&"
export * from "./hotSell.vue?vue&type=script&lang=js&"
import style0 from "./hotSell.vue?vue&type=style&index=0&id=3bdba48b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdba48b",
  null
  
)

export default component.exports